// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #20448e;
  align-items: center;
  height: 4rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 50;
  font-family: 'Montserrat', sans-serif;

  .left-nav-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .profile {
    margin-right: 10px;
    display: flex;
    align-items: center;

    .user-name {
      font-size: 14px;
    }
  }

  a {
    text-decoration: none;
  }
}

.bf-link {
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  color: white;
  &:hover {
    text-shadow: 0 0 1px white, 0 0 1px white, 0 0 1px white;
  }
}

nav {
  background-color: #20448e;
  padding-left: 10px;

  * {
    color: rgba(255, 255, 255, 0.9);
    font-size: 16px;
    line-height: 22px;
  }

  .icon {
    margin-left: 10px;
    margin-right: 20px;
    img {
      width: 70px;
    }
  }

  .dropdown-wrapper {
    padding: 0 1.25rem;
    position: relative;
    user-select: none;
    height: 100%;
    align-items: center;
    display: flex;

    div {
      font-weight: 500;
      display: block;
      width: max-content;
      text-decoration: none;
      cursor: pointer;
    }

    .nav-dropdown {
      min-width: 120px;
      height: auto;
      max-height: 0;
      overflow: hidden;
      position: absolute;
      top: 40px;
      background: #20448e;
      transition: all 0.5s;
      z-index: 1000;
      padding-left: 15px;
      padding-right: 15px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      .item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px solid #fff;
        height: 32px;
        color: white;
        font-size: 18px;
        > * {
          margin: 0 5px;
        }
        &:last-child {
          border-bottom: none;
          padding-bottom: 5px;
        }
        svg {
          fill: white;
          color: white;
        }
      }
      .gray {
        color: #505050;
        border-bottom: 1px solid #505050;
        height: 50px !important;
      }
    }

    &:hover {
      .nav-dropdown {
        max-height: 500px;
      }
    }
  }
  .active {
    color: #f09637 !important;
    position: relative;
    &:hover {
      text-shadow: none !important;
    }

    @keyframes aniActive {
      from {
        width: 0;
      }
      to {
        width: 100%;
      }
    }
  }
}

.inline-center {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  grid-gap: 10px;
}

.notification-badge {
  height: 17px;
  position: absolute;
  top: -30%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  line-height: 15px;
  color: white;
  background-color: #f56565;
  border: 1px solid #ffffff;
  border-radius: 9999px;
  padding: 0 8px;
  width: max-content;
}

.notification-line {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  background-color: white;
  z-index: 100;

  span {
    font-size: 14px;
  }
}

.bold-text {
  font-weight: bold;
}

.pointer {
  cursor: pointer;
}

.noti-bell {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
}

.noti-dropdown {
  position: absolute;
  background: #ffffff;
  max-height: 180px;
  overflow: auto;
  padding: 4px;
  border-radius: 8px;
  width: 750px;
  left: -490px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

  .env-input-wrapper {
    padding: 5px;
  }

  .env-input {
    width: 100%;
    height: 25px;
    border-radius: 7px;
    border: 1px solid #505050;
  }

  .env-input:focus {
    border: 1px solid #0189e3;
  }

  .noti-item {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .noti-item:hover {
    background: #d9d9d9;
    border-radius: 8px;
  }

  .noti-item.active {
    background: rgba(1, 137, 227, 0.15);
    border-radius: 8px;
  }

  * {
    color: #000000;
  }

  .quantity {
    color: #f56565;
  }

  .copy-btn {
    img {
      display: block;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Nav/Nav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,qCAAqC;;EAErC;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;;IAEnB;MACE,eAAe;IACjB;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;EAElB;IACE,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB;MACE,WAAW;IACb;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,aAAa;;IAEb;MACE,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,qBAAqB;MACrB,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,gBAAgB;MAChB,kBAAkB;MAClB,SAAS;MACT,mBAAmB;MACnB,oBAAoB;MACpB,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,8BAA8B;MAC9B,+BAA+B;;MAE/B;QACE,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,6BAA6B;QAC7B,YAAY;QACZ,YAAY;QACZ,eAAe;QACf;UACE,aAAa;QACf;QACA;UACE,mBAAmB;UACnB,mBAAmB;QACrB;QACA;UACE,WAAW;UACX,YAAY;QACd;MACF;MACA;QACE,cAAc;QACd,gCAAgC;QAChC,uBAAuB;MACzB;IACF;;IAEA;MACE;QACE,iBAAiB;MACnB;IACF;EACF;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB;MACE,4BAA4B;IAC9B;;IAEA;MACE;QACE,QAAQ;MACV;MACA;QACE,WAAW;MACb;IACF;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;;EAEZ;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,4EAA4E;;EAE5E;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;MACE,cAAc;IAChB;EACF;AACF","sourcesContent":[".nav-bar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: #20448e;\n  align-items: center;\n  height: 4rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  z-index: 50;\n  font-family: 'Montserrat', sans-serif;\n\n  .left-nav-bar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .profile {\n    margin-right: 10px;\n    display: flex;\n    align-items: center;\n\n    .user-name {\n      font-size: 14px;\n    }\n  }\n\n  a {\n    text-decoration: none;\n  }\n}\n\n.bf-link {\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  color: white;\n  &:hover {\n    text-shadow: 0 0 1px white, 0 0 1px white, 0 0 1px white;\n  }\n}\n\nnav {\n  background-color: #20448e;\n  padding-left: 10px;\n\n  * {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .icon {\n    margin-left: 10px;\n    margin-right: 20px;\n    img {\n      width: 70px;\n    }\n  }\n\n  .dropdown-wrapper {\n    padding: 0 1.25rem;\n    position: relative;\n    user-select: none;\n    height: 100%;\n    align-items: center;\n    display: flex;\n\n    div {\n      font-weight: 500;\n      display: block;\n      width: max-content;\n      text-decoration: none;\n      cursor: pointer;\n    }\n\n    .nav-dropdown {\n      min-width: 120px;\n      height: auto;\n      max-height: 0;\n      overflow: hidden;\n      position: absolute;\n      top: 40px;\n      background: #20448e;\n      transition: all 0.5s;\n      z-index: 1000;\n      padding-left: 15px;\n      padding-right: 15px;\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n\n      .item {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        border-bottom: 1px solid #fff;\n        height: 32px;\n        color: white;\n        font-size: 18px;\n        > * {\n          margin: 0 5px;\n        }\n        &:last-child {\n          border-bottom: none;\n          padding-bottom: 5px;\n        }\n        svg {\n          fill: white;\n          color: white;\n        }\n      }\n      .gray {\n        color: #505050;\n        border-bottom: 1px solid #505050;\n        height: 50px !important;\n      }\n    }\n\n    &:hover {\n      .nav-dropdown {\n        max-height: 500px;\n      }\n    }\n  }\n  .active {\n    color: #f09637 !important;\n    position: relative;\n    &:hover {\n      text-shadow: none !important;\n    }\n\n    @keyframes aniActive {\n      from {\n        width: 0;\n      }\n      to {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.inline-center {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  grid-gap: 10px;\n}\n\n.notification-badge {\n  height: 17px;\n  position: absolute;\n  top: -30%;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 12px;\n  line-height: 15px;\n  color: white;\n  background-color: #f56565;\n  border: 1px solid #ffffff;\n  border-radius: 9999px;\n  padding: 0 8px;\n  width: max-content;\n}\n\n.notification-line {\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  z-index: 100;\n\n  span {\n    font-size: 14px;\n  }\n}\n\n.bold-text {\n  font-weight: bold;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.noti-bell {\n  position: relative;\n  margin-right: 20px;\n  cursor: pointer;\n}\n\n.noti-dropdown {\n  position: absolute;\n  background: #ffffff;\n  max-height: 180px;\n  overflow: auto;\n  padding: 4px;\n  border-radius: 8px;\n  width: 750px;\n  left: -490px;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n\n  .env-input-wrapper {\n    padding: 5px;\n  }\n\n  .env-input {\n    width: 100%;\n    height: 25px;\n    border-radius: 7px;\n    border: 1px solid #505050;\n  }\n\n  .env-input:focus {\n    border: 1px solid #0189e3;\n  }\n\n  .noti-item {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .noti-item:hover {\n    background: #d9d9d9;\n    border-radius: 8px;\n  }\n\n  .noti-item.active {\n    background: rgba(1, 137, 227, 0.15);\n    border-radius: 8px;\n  }\n\n  * {\n    color: #000000;\n  }\n\n  .quantity {\n    color: #f56565;\n  }\n\n  .copy-btn {\n    img {\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
